/** Comandos escaneables del cajero 0E3 — prefijo fijo, sin colisión con EAN. */

export const POS_CMD_PREFIX = '0E3_CMD_';

const CMD_PATTERN = /^0E3_CMD_[A-Z0-9_]+$/;

/** Comandos V1 autorizados (id sin prefijo, en mayúsculas). */
export const POS_SCAN_COMMANDS_V1 = [
  'FOCO',
  'BUSCAR',
  'PANTALLA',
  'LIMPIAR',
  'EFECTIVO',
  'TARJETA',
  'COBRAR',
  'NUEVA',
  'CIERRE'
];

/**
 * Normaliza lectura del escáner: trim, mayúsculas, sin CR/LF finales.
 * @param {string} raw
 * @returns {string}
 */
export function normalizePosScanCommand(raw) {
  return String(raw ?? '')
    .replace(/[\r\n]+$/g, '')
    .trim()
    .toUpperCase();
}

/**
 * @param {string} raw
 * @returns {string | null} Id del comando (ej. "COBRAR") o null si no es comando válido.
 */
export function parsePosScanCommand(raw) {
  const normalized = normalizePosScanCommand(raw);
  if (!normalized || !normalized.startsWith(POS_CMD_PREFIX)) {
    return null;
  }
  if (!CMD_PATTERN.test(normalized)) {
    return null;
  }
  const id = normalized.slice(POS_CMD_PREFIX.length);
  if (!POS_SCAN_COMMANDS_V1.includes(id)) {
    return null;
  }
  return id;
}

/** Etiquetas breves para toast / log. */
export const POS_SCAN_COMMAND_LABELS = {
  FOCO: 'Foco escáner',
  BUSCAR: 'Buscar',
  PANTALLA: 'Pantalla completa',
  LIMPIAR: 'Limpiar campo',
  EFECTIVO: 'Efectivo',
  TARJETA: 'Tarjeta',
  COBRAR: 'Cobrar',
  NUEVA: 'Nueva venta',
  CIERRE: 'Cierre de caja'
};
